export const consultarMiembros200 = {
    mensajeAdvertencia: {
      descripcionMensaje: 'string',
      idMensaje: 'string'
    },
    resultBusqFamiliares: [
      {
        apellido1: 'PEREZ',
        apellido2: 'PEREZ',
        codClienteRic: '32029347',
        email: 'prueba@gmail.com',
        esClienteGestor: 'N',
        estadoMiembro: 'CF',
        fechaNacimiento: '1991-12-05T00:00:00+01:00',
        mensajeAdvertencia: {
          descripcionMensaje: 'string',
          idMensaje: 'string'
        },
        movil: 678987867,
        nombre: 'ANA',
        numDocum: '11844244A',
        parentesco: 'HM',
        tipDocum: 'NIF',
      },
      {
        apellido1: 'GÓMEZ',
        apellido2: 'LÓPEZ',
        codClienteRic: '54353634',
        email: 'carloslg@gmail.com',
        esClienteGestor: 'N',
        estadoMiembro: 'PC',
        fechaNacimiento: '1991-12-05T00:00:00+01:00',
        mensajeAdvertencia: {
          descripcionMensaje: 'string',
          idMensaje: 'string'
        },
        movil: 665645322,
        nombre: 'CARLOS',
        numDocum: '83234549X',
        parentesco: 'RR',
        tipDocum: 'NIF',
      },
      {
        apellido1: 'PERALTA',
        apellido2: 'RUIZ',
        codClienteRic: '88973483',
        email: 'tomaspr@gmail.com',
        esClienteGestor: 'N',
        estadoMiembro: '',
        fechaNacimiento: '1991-12-05T00:00:00+01:00',
        mensajeAdvertencia: {
          descripcionMensaje: 'string',
          idMensaje: 'string'
        },
        movil: 678987867,
        nombre: 'TOMÁS',
        numDocum: '58955404X',
        parentesco: 'TL',
        tipDocum: 'NIF',
      },
    ]
};

export const consultarMiembrosNoGestor200 = {
  mensajeAdvertencia: {
    descripcionMensaje: 'string',
    idMensaje: 'string'
  },
  resultBusqFamiliares: [
    {
      apellido1: 'LOPEZ',
      apellido2: 'CARMONA',
      codClienteRic: '32029347',
      email: 'prueba@gmail.com',
      esClienteGestor: 'S',
      estadoMiembro: 'CF',
      fechaNacimiento: '1991-12-05T00:00:00+01:00',
      mensajeAdvertencia: {
        descripcionMensaje: 'string',
        idMensaje: 'string'
      },
      movil: 678987867,
      nombre: 'ANTONIO',
      numDocum: '11844244A',
      parentesco: null,
      tipDocum: 'NIF',
    },
    {
      apellido1: 'GÓMEZ',
      apellido2: 'LÓPEZ',
      codClienteRic: '54353634',
      email: 'carloslg@gmail.com',
      esClienteGestor: 'N',
      estadoMiembro: 'CF',
      fechaNacimiento: '1991-12-05T00:00:00+01:00',
      mensajeAdvertencia: {
        descripcionMensaje: 'string',
        idMensaje: 'string'
      },
      movil: 665645322,
      nombre: 'CARLOS',
      numDocum: '83234549X',
      parentesco: null,
      tipDocum: 'NIF',
    },
    {
      apellido1: 'PERALTA',
      apellido2: 'RUIZ',
      codClienteRic: '88973483',
      email: 'tomaspr@gmail.com',
      esClienteGestor: 'N',
      estadoMiembro: '',
      fechaNacimiento: '1991-12-05T00:00:00+01:00',
      mensajeAdvertencia: {
        descripcionMensaje: 'string',
        idMensaje: 'string'
      },
      movil: 678987867,
      nombre: 'TOMÁS',
      numDocum: '58955404X',
      parentesco: null,
      tipDocum: 'NIF',
    },
  ]
};

export const clienteGestor200 = {
  apellido1: 'PEREZ',
  apellido1UsuarioConectado: 'López',
  apellido2: 'PEREZ',
  apellido2UsuarioConectado: 'Carmona',
  codClientRIC: '32037355',
  codFamily: 'FAM2769',
  duplicado: 'N',
  enFamiliaNoDeBaja: 'N',
  isGestor: 'S',
  estadoCliente: 'PA',
  familiaEnTramite: 'N',
  invitacionPendiente: 'N',
  menorMasDeUnaFamilia: 'N',
  mensajeAdvertencia: {
    descripcionMensaje: 'string"',
    idMensaje: 'string"',
  },
  nombreGestor: 'ANA',
  nombreUsuarioConectado: 'Antonio',
  puedeSerGestor: 'N',
  puedeSerInvitado: 'N',
};
export const clienteNoGestor200 = {
  apellido1: 'López',
  apellido1UsuarioConectado: 'López',
  apellido2: 'García',
  apellido2UsuarioConectado: 'García',
  codClientRIC: '32037355',
  codFamily: 'FAM2769',
  duplicado: 'N',
  enFamiliaNoDeBaja: 'N',
  isGestor: 'N',
  estadoCliente: 'PA',
  familiaEnTramite: 'N',
  invitacionPendiente: 'N',
  menorMasDeUnaFamilia: 'N',
  mensajeAdvertencia: {
    descripcionMensaje: 'string',
    idMensaje: 'string',
  },
  nombreGestor: 'Antonio',
  nombreUsuarioConectado: 'Laura',
  puedeSerGestor: '',
  puedeSerInvitado: '',
};
